import { isMenuQrTable } from './menuTableRules'

export const isOrderButtonHiddenForTable = (restaurantCode: string, tableId?: string | null) => {
  return isMenuQrTable(restaurantCode, tableId)
}
